import {Dialog, DialogTitle, Paper} from '@material-ui/core'
import H3 from '../Typography/H3'
import ButtonLarge from '../Buttons/ButtonLarge'
import {SuccessButtonGrid, SuccessCheckIcon} from './styled'

export type SuccessDialogProps = {
  title?: string
  onDismiss: () => void
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({title, onDismiss}: SuccessDialogProps) => {
  const open = title !== undefined && title.length > 0
  return (
    <Dialog open={open ? open : false}>
      <DialogTitle>
        <H3 align="center">{title}</H3>
      </DialogTitle>
      <Paper elevation={0}>
        <SuccessCheckIcon />
      </Paper>
      <SuccessButtonGrid container justify="flex-end" alignItems="flex-end">
        <ButtonLarge onClick={() => onDismiss()}>Ok!</ButtonLarge>
      </SuccessButtonGrid>
    </Dialog>
  )
}

export default SuccessDialog
